// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__24GmO","amount":"Amount_amount__2zl36","tip":"Amount_tip__B6rRA","tipHeader":"Amount_tipHeader__14zW-","tipsWrap":"Amount_tipsWrap__38DfJ"};